/* eslint-disable no-plusplus */
// Função para gerar número aleatório entre min e max (inclusive)
const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min

// Configuração das colunas
const COLUMN_CONFIG = [
  { id: 'newOrders', title: 'Novo chamado' },
  { id: 'triage', title: 'Triagem' },
  { id: 'allocateProvider', title: 'Alocar prestador' },
  { id: 'waitingClient', title: 'Aguardando cliente' },
  { id: 'waitingBudget', title: 'Aguardando orçamento' },
  { id: 'negotiateBudget', title: 'Negociar orçamento' },
  { id: 'reviewBudget', title: 'Revisar orçamento' },
  { id: 'sendBudgetToPayer', title: 'Enviar orçamento ao pagador' },
  { id: 'waitingPayerApproval', title: 'Aguardando aprovação do pagador' },
  {
    id: 'allocateProviderPreApprovedBudget',
    title: 'Alocar prestador para orçamento aprovado',
  },
  { id: 'waitingExecution', title: 'Aguardando execução' },
  { id: 'waitingFinalization', title: 'Analisar finalização' },
  { id: 'reprovedService', title: 'Serviço reprovado' },
  { id: 'finished', title: 'Chamado finalizado' },
  { id: 'cancelled', title: 'Chamado cancelado' },
]

// Função para gerar dados skeleton aleatórios
const generateSkeletonData = () => {
  const data = {}
  const columnIds = COLUMN_CONFIG.map(col => col.id)
  let cardCounter = 1

  // Criar root
  data.root = {
    id: 'root',
    title: 'Root',
    children: columnIds,
    totalChildrenCount: columnIds.length,
    parentId: null,
  }

  // Criar colunas e cards
  columnIds.forEach(columnId => {
    const columnConfig = COLUMN_CONFIG.find(col => col.id === columnId)
    const cardCount = getRandomNumber(2, 5) // Entre 1 e 5 cards por coluna
    const cardIds = []

    // Gerar IDs dos cards para esta coluna
    for (let i = 0; i < cardCount; i++) {
      cardIds.push(`skeleton-card-${cardCounter}`)
      cardCounter++
    }

    // Criar coluna
    data[columnId] = {
      id: columnId,
      title: columnConfig.title,
      children: cardIds,
      totalChildrenCount: cardCount,
      parentId: 'root',
      type: 'column',
      isSkeleton: true,
    }

    // Criar cards para esta coluna
    cardIds.forEach(cardId => {
      data[cardId] = {
        id: cardId,
        title: `Skeleton Card ${cardId.split('-')[2]}`,
        content: {},
        parentId: columnId,
        children: [],
        totalChildrenCount: 0,
        type: 'card',
        isSkeleton: true,
      }
    })
  })

  return data
}

export const SKELETON_DATA = generateSkeletonData()
